import { useQuery } from "react-query"

import axios from "axios"

import {
  MemberMerchantDetailResponse,
  ServiceFailedToReturn,
  FailureMessage,
} from "./types"
import { memberMerchantGetPath } from "./utils"

export const useMemberMerchantDetails = (memberUuid: string) => {
  const apiCall = async () => {
    try {
      const { data } = await axios.get(memberMerchantGetPath(memberUuid), {
        headers: {
          "Content-Type": "application/json",
        },
        validateStatus: (status: number) => status === 200,
      })

      return data
    } catch (err: any) {
      return {
        failureMessage: FailureMessage.OPERATION_ERROR,
      }
    }
  }

  return useQuery<
    MemberMerchantDetailResponse & ServiceFailedToReturn,
    { message: string }
  >("member-merchant-detail", apiCall, {
    retry: 0,
    refetchOnWindowFocus: false,
  })
}
